<template>
    <div class="card">
        <h1 class="card-header text-center">Contact Information</h1>
        <div class="card-body">
            <form @submit.prevent="submit">
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="searchEmail">Please enter the email of the contact you want to search for or create:</label><br/>
                        <input id="searchEmail" required type="email" class="form-control"
                               v-model.trim="$v.searchEmail.$model" :class="{'is-invalid': $v.searchEmail.$error}"><p></p>
                        <div class="invalid-feedback">
                            <span v-if="!$v.searchEmail.minLength || !$v.searchEmail.required || $v.searchEmail.invalid " class="invalid-feedback">Email is required</span>
                            <span v-if="!$v.searchEmail.email" class="invalid-feedback">Email is not valid</span>
                        </div>
                    </div>
                </div>
                <b-button variant="primary" v-on:click="submit">Search</b-button>
            </form>
        </div>
        <div v-if="this.contactResults">
            <div class="card-body" v-if="this.contactResults.length > 0">
                <h3>A contact with this email already exists: {{this.contactResults[0].prepareEmail}}</h3>
                <p>If a contact below is the same person you need, please select it.
                    If you do not see the correct contact data, please click on, Add a new contact.</p>

                <div class="row">
                    <div class="col-auto"><strong>Action</strong></div>
                    <div class="col-auto"><strong>Plan ID</strong></div>
                    <div class="col"><strong>Company Name</strong></div>
                    <div class="col"><strong>Contact</strong></div>
                    <div class="col"><strong>Email</strong></div>
                </div>

                <div class="form-row border" v-for="contactResult in this.contactResults" v-bind:key="contactResult.contactId">
                    <div class="col-lg-1">
                        <div class="vertical-center"><b-button variant="primary" v-on:click="selectData(contactResult)">Select</b-button></div>
                    </div>
                    <div class="col-lg-11">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-auto">{{contactResult.hccisId}}</div>
                                <div class="col">{{contactResult.prepareorgName}}</div>
                                <div class="col">{{contactResult.prepareNamef}} {{contactResult.prepareNamel}}</div>
                                <div class="col">{{contactResult.prepareEmail}}</div>
                            </div>
                            <!--{{contactResult.prepareNamef}} {{contactResult.prepareNamel}}, {{contactResult.prepareEmail}}, State Farm, {{contactResult.preparePhone}} Ext {{contactResult.prepareExt}}, {{contactResult.prepareAddress}}  {{contactResult.streetAddress2}},
                                {{contactResult.prepareCity}}, {{contactResult.prepareState}}, {{contactResult.prepareZip}}, {{contactResult.prepareCounty}}, Fax: {{contactResult.prepareFax ? contactResult.prepareFax : 'none'}}, <strong>Supervisor: </strong> {{contactResult.prepareSupNamef}} {{prepareSupNamel}},
                                {{contactResult.prepareSupEmail}}, {{contactResult.prepareSupTitle}}, {{contactResult.prepareSupPhone}}-->
                        </div>
                    </div>

                </div>
                <div style="padding-top: 10px"> <b-button variant="primary" v-on:click="addNewContact()">Add a new person</b-button></div>
            </div>
            <div class="card-body" v-else>
                <h3>A contact with this email was not found.</h3>
                <p>To create a new contact, please click on Add a new contact.</p>
                <div style="padding-top: 10px"> <b-button variant="primary" v-on:click="addNewContact()">Add a new person</b-button></div>
            </div>
        </div>
    </div>
</template>

<script>

import { required, minLength, email  } from 'vuelidate/lib/validators'
import Form from "../mixins/form";
import lambdaURL from '../lambda'

export default {
    props: {
        originalContact: [Object]
    },
    name: 'Search',
    data() {
        return {
            hccisId: '',
            searchEmail: '',
            hasError: false,
            contactResults: null,
            newContact: {
                contactId: null,
                hccisContactId: null,
                sourceTypeId: 86,
                salutation: '',
                title: '',
                //contactTypeId: null,
                prepareEmail: '',
                prepareNamef: '',
                prepareorgName: '',
                prepareAddress: '',
                streetAddress2: '',
                prepareCity: '',
                prepareCounty: '',
                prepareState: '',
                prepareZip: '',
                prepareSupTitle: '',
                prepareSupPhone: '',
                company: '',
                prepareNamel: '',
                preparePhone: '',
                phoneExt: '',
                prepareFax: '',
                prepareSupNamef: '',
                prepareSupNamel: '',
                prepareSupEmail: '',
                newContact: 1
                //reportYear:
            },
            selectedContact: {
                contactId: null,
                hccisContactId: null,
                sourceTypeId: null,
                salutation: '',
                title: '',
                //contactTypeId: null,
                prepareEmail: '',
                prepareNamef: '',
                prepareorgName: '',
                prepareAddress: '',
                streetAddress2: '',
                prepareCity: '',
                prepareCounty: '',
                prepareState: '',
                prepareZip: '',
                prepareSupTitle: '',
                prepareSupPhone: '',
                company: '',
                prepareNamel: '',
                preparePhone: '',
                phoneExt: '',
                prepareFax: '',
                prepareSupNamef: '',
                prepareSupNamel: '',
                prepareSupEmail: '',
                newContact: null
                //reportYear:
            },
        }
    },
    validations: {
        searchEmail: {
            required, minLength: minLength(1), email
        }
    },
    methods: {

        validationStatus: function(validation) {
            return typeof validation != "undefined" ? validation.$error : false;
        },

        selectData(contactResult) {
            let selectedResult = Object.assign(this.$data.selectedContact, contactResult);
            this.$bvModal.hide('modal-search-contacts')
            this.$bvModal.hide('modal-search-courtesy-contact')
            this.$bvModal.hide('modal-search-courtesy-contact-2')
            this.$emit('input', selectedResult)
            //this.$emit('resetSelection')
        },

        addNewContact() {
            let newResult = this.$data.newContact
            newResult.prepareEmail = this.searchEmail
            //newResult.prepareEmail = this.searchEmail
            //newResult.contactTypeId = this.originalContact.contactTypeId
            this.$bvModal.hide('modal-search-contacts')
            this.$bvModal.hide('modal-search-courtesy-contact')
            this.$bvModal.hide('modal-search-courtesy-contact-2')
            this.$emit('input', newResult)
            this.$emit('enable', false)
            //this.$emit('resetSelection')
            //console.log(newResult)
            /**Object.assign(this.$data.contact, this.$data.newResult);**/
        },

        submit() {
            //console.log(this.$data)
            //console.log(this.originalContact)
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.hasError = true;
            } else {
                this.hasError = false;
                //lambdaURL.searchContacts(this.searchEmail, this.originalContact.contactTypeId).then((res) => {
                lambdaURL.searchContacts(this.searchEmail).then((res) => {
                    this.contactResults= res;
                })
                    .catch((err) => {
                    })
                /*window.location.replace('/viewcontect');*/
            }

        }
    }

}

</script>

<style>


</style>